import IconModal from "./IconModal";

export default IconModal;



// WEBPACK FOOTER //
// ./src/shared/components/IconModal/index.js